import clsx from 'clsx'
import React, { useState } from 'react'

// note: AddModal もリプレイスで作成したけど、もともと使用されていなかったっぽい？
type AddModalProps = {
  open?: boolean
}
export const AddModal = ({ open }: AddModalProps) => {
  return (
    <div id="add_modal" className={clsx('Modal', open && '-opened')}>
      <div className="Modal__inner">
        <div className="Modal__dialog" data-target="modal.dialog">
          <div className="Modal__body">
            <div className="Modal__label -confirm" data-target="modal.label">
              このブックマークを
              <br />
              実行しますか？
            </div>
          </div>
          <div className="Modal__footer -confirm">
            <button
              id="add_bookmark_cancel_button"
              className="Button -color-gray10 -rounded"
              type="button"
            >
              <span className="Button__inner">
                <span className="Button__label">キャンセル</span>
              </span>
            </button>
            <button
              id="add_bookmark_button"
              className="Button -color-primary -rounded"
            >
              <span className="Button__inner">
                <span className="Button__label">ブックマーク</span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

type RemoveModalProps = {
  open?: boolean
  handleClose: VoidFunction
  handleUnbookmark: (removeModal?: boolean) => void
}

export const RemoveModal = ({
  open,
  handleClose,
  handleUnbookmark,
}: RemoveModalProps) => {
  const [checked, setChecked] = useState(false)
  const handleSubmit = async () => {
    await handleUnbookmark(checked)
    handleClose()
  }
  return (
    <div id="remove_modal" className={clsx('Modal', open && '-opened')}>
      <div className="Modal__inner">
        <div className="Modal__dialog" data-target="modal.dialog">
          <div className="Modal__body">
            <div className="Modal__label -confirm" data-target="modal.label">
              このブックマークを
              <br />
              解除しますか？
            </div>
          </div>
          <div className="Modal__footer -confirm">
            <button
              id="remove_bookmark_cancel_button"
              className="Button -color-gray10 -rounded -full"
              type="button"
              onClick={handleClose}
            >
              <span className="Button__inner">
                <span className="Button__label">キャンセル</span>
              </span>
            </button>
            <button
              id="remove_bookmark_button"
              className="Button -color-primary -rounded -full"
              onClick={handleSubmit}
            >
              <span className="Button__inner">
                <span className="Button__label">解除する</span>
              </span>
            </button>
          </div>
          <div className="Modal__checkbox">
            <label className="Checkbox" htmlFor="remove_bookmark_confirm">
              <input
                type="checkbox"
                id="remove_bookmark_confirm"
                className="Checkbox__input"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <span className="Checkbox__icon"></span>
              <span className="Checkbox__label">今後表示しない</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
